import { produce } from "immer";

import type { IIdentifyPayload, ProfileActions } from "./actions";

export interface IProfileState {
  user: IIdentifyPayload["user"] | null;
  organization: IIdentifyPayload["organization"] | null;
}

const initialState: IProfileState = {
  user: null,
  organization: null,
};

export const profileReducer = produce((draft: IProfileState, action: ProfileActions) => {
  switch (action.type) {
    case "IDENTIFY": {
      draft.user = action.payload.user;
      draft.organization = action.payload.organization;
      break;
    }
    case "CLEAR_IDENTITY": {
      draft.user = null;
      draft.organization = null;
      break;
    }
    default:
      break;
  }
}, initialState);
